import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_2: FaireProductEntity = {
  token: "casa-bosques-2",
  type: "product",
  name: "Date Caramel 74%",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.faire.com/fastly/216eb341e6eb732447f5d37cd12ecb8b60a057b9682643e38ab1b9678dfa55d9.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 10,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
